







































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { ContactV3, CustomField, CustomFieldData } from '@/models/Contact';
import SingleSelect from '@/components/SingleSelect.vue';
import DynamicForm from '@/components/Form/DynamicForm.vue';
import { FileUpload } from '@/models/FileUpload';
import http from '@/services/Http';
import { websiteText } from '@/mixins/websiteTexts';
import RadioGroup from '../Form/RadioGroup.vue';
import CheckboxGroup from '../Form/CheckboxGroup.vue';

declare var grecaptcha: any;

@Component({
    components: {
        DynamicForm
    }
})
export default class ContactFormV3 extends Vue {
    protected form: ContactV3;
    
    @Prop({ default: '[]' }) customFields!: string;
    get customFieldsList(): CustomField[] {
        return JSON.parse(this.customFields);
    }

    private showForm: boolean = true;
    // private customFieldErrors: { [key: number]: string } = {

    // };
    private errorMsgs: string[] = [];
    private title: string;
    private text: '';
    private dataLayer = (window as any).dataLayer || [];
    private selectedOrgName = '';
    private translations: any = window.__litium.translation;
    private _websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    private selectedProducts: string[] = [];
    constructor() {
        super();
        this.form = {
            token: '',
            customFields: []
        };
        this.selectedOrgName = this.$attrs['data-retailer-name'];
        this.title = this.$attrs['data-title'];
        this.text = JSON.parse(this.$attrs['data-text']);

        const cfList: CustomField[] = this.customFieldsList || [];
        this.form.customFields = cfList.map((cf: CustomField) => ({
            title: cf.placeholder || '',
            value: '',
            files: [] as FileUpload[]
        } as CustomFieldData));

        // this.customFieldErrors = {};
        
        // cfList.forEach((_, i) => {
        //     this.$set(this.customFieldErrors, i, '');
        // });
    }

    // private clearCustomFieldError(index: number) {
    //     this.customFieldErrors[index] = '';
    // }

    // private validateField(index: number): boolean {
    //     const field = this.customFieldsList[index];
    //     const fieldData = this.form.customFields[index];
    //     const fieldValue = fieldData.value;
    //     const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

    //     this.customFieldErrors[index] = '';

    //     if (field.mandatory && (!fieldValue || fieldValue.trim() === '') && (!fieldData.files || fieldData.files.length === 0)) {
    //         this.customFieldErrors[index] = this._websiteText('site.contactform.missingmessage', [field.placeholder]);
    //         return false;
    //     }

    //     if (field.fieldType === 'EmailField' && fieldValue && !regEmail.test(fieldValue.toLowerCase())) {
    //         this.customFieldErrors[index] = this._websiteText('site.contactform.emailincorrect');
    //         return false;
    //     }

    //     return true;
    // }

    // private updateCustomField(index: number, placeholder: string, val: any) {
    //     let files: FileUpload[] = [];
    //     let valueToStore: string = '';

    //     const looksLikeFileUpload = (obj: any) => {
    //         return obj && typeof obj === 'object' && (
    //             'fileSystemId' in obj || 'fileName' in obj || 'originalFileName' in obj || 'fileUrl' in obj
    //         );
    //     };

    //     if (Array.isArray(val) && val.length > 0 && looksLikeFileUpload(val[0])) {
    //         files = val as FileUpload[];
    //     } else if (looksLikeFileUpload(val)) {
    //         files = [val as FileUpload];
    //     } else {
    //         let incoming = val;
    //         if (incoming && typeof incoming === 'object' && 'target' in incoming) {
    //             incoming = (incoming.target && incoming.target.value) || '';
    //         }
    //         const selected = Array.isArray(incoming) ? incoming[0] : incoming;
    //         valueToStore = selected != null ? String(selected) : '';
    //     }

    //     this.form.customFields[index] = ({
    //         title: placeholder,
    //         value: valueToStore,
    //         files: files
    //     } as CustomFieldData);

    //     if (this.customFieldErrors[index]) {
    //         this.validateField(index);
    //     }    
    // }

    private submitForm(emittedFormData: CustomFieldData[]) {
        this.errorMsgs = [];
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;
        this.form.customFields = emittedFormData;

        const submit = this.submit;
        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptchaSiteKey, {
                    action: 'submit'
                })
                .then(function(token: string) {
                    submit(token);
                });
        });
    }

    private submit(token: string) {
        const sendData = JSON.stringify({
            token: token,
            event: 'reseller-form',
            'reseller-formtype': 'contact',
            store: this.selectedOrgName,
            customFields: this.form.customFields,
        });

        http.post('/api/contactform/v3', sendData)
            .then(() => {
                this.showForm = false;
                setTimeout(() => {
                    const successEl = this.$refs.v3Form as HTMLElement;
                    
                    if (successEl) {
                        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            })
            .catch((err: string) => {
                console.error('Error sending contact form:', err);
            });
    }

    // private validateForm(): boolean {
    //     let isValid = true;
    //     this.customFieldsList.forEach((_, index) => {
    //         const fieldIsValid = this.validateField(index);
    //         if (!fieldIsValid) {
    //             isValid = false;
    //         }
    //     });
    //     return isValid;
    // }
}
